import { render, staticRenderFns } from "./WorkCalendarTaskAssignmentInfo.vue?vue&type=template&id=6f1428dc&scoped=true"
import script from "./WorkCalendarTaskAssignmentInfo.vue?vue&type=script&lang=js"
export * from "./WorkCalendarTaskAssignmentInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarTaskAssignmentInfo.vue?vue&type=style&index=0&id=6f1428dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1428dc",
  null
  
)

export default component.exports